function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStonks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "#f0f0f0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M425.75 385.65H428.25V383.15V374.85V372.35H425.75H390.225V325.05V322.55H387.725H379.275H376.775V325.05V383.15V385.65H379.275H425.75ZM470.5 379C470.5 331.811 431.432 293.5 383.5 293.5C335.568 293.5 296.5 331.811 296.5 379C296.5 426.189 335.568 464.5 383.5 464.5C431.432 464.5 470.5 426.189 470.5 379ZM457.05 379C457.05 418.767 424.096 451.2 383.5 451.2C342.904 451.2 309.95 418.767 309.95 379C309.95 339.233 342.904 306.8 383.5 306.8C424.096 306.8 457.05 339.233 457.05 379Z",
    fill: "white",
    stroke: "#D7D7D7",
    style: {
      fill: "#f0f0f0",
      fillOpacity: 1,
      stroke: "#D7D7D7",
      stroke: "color(display-p3 0.8417 0.8417 0.8417)",
      strokeOpacity: 1
    },
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.915 350.339L146.773 352.01L148.445 350.153L237.2 251.55L288.367 282.25L290.041 283.255L291.421 281.874L381.5 191.796V213.333V215.833H384H405.333H407.833V213.333V149.333V146.833H405.333H341.333H338.833V149.333V170.667V173.167H341.333H362.873L285.959 250.105L233.9 218.87L232.133 217.81L230.755 219.341L128.862 332.541L127.188 334.4L129.048 336.072L144.915 350.339ZM281.915 404.828L281.503 402.833H279.467H109.167V85.3333V82.8333H106.667H85.3334H82.8334V85.3333V426.667V429.167H85.3334H286.267H290.093L288.556 425.662C285.62 418.969 283.394 411.986 281.915 404.828Z",
    fill: "#f0f0f0",
    stroke: "#D7D7D7",
    style: {
      fill: "#f0f0f0",
      fillOpacity: 1,
      stroke: "#D7D7D7",
      stroke: "color(display-p3 0.8417 0.8417 0.8417)",
      strokeOpacity: 1
    },
    strokeWidth: 5
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStonks);
export default __webpack_public_path__ + "static/media/stonks.82d92c486bf55c6d865c0dc181465bcf.svg";
export { ForwardRef as ReactComponent };